export default __webpack_public_path__ + "static/media/project-img-1.9d2dcff4.png";